export const checkIfReminderIsExpired = (remindAt) => new Date(new Date(remindAt).toDateString()) < new Date(new Date().toDateString())
